import FileModel from '../model/FileModel'
import ImageSelectControl from '../../../lib/ui/ImageSelectControl'
import TextControl from '../../../lib/ui/TextControl'

export default class FileForm {
  constructor (element, args) {
    let fieldsetFile = document.createElement('fieldset')
    let legendFile = document.createElement('legend')
    legendFile.innerHTML = 'Bestandsgegevens'
    fieldsetFile.appendChild(legendFile)

    this.id = new TextControl(fieldsetFile, {label: 'Id', value: args.file.values.id, onchange: args.onchange})
    this.contents = new TextControl(fieldsetFile, {label: 'Inhoud', value: args.file.values.contents, onchange: args.onchange})
  
    let fragment = document.createDocumentFragment()
    fragment.appendChild(fieldsetFile)
    element.appendChild(fragment)
  }

  getValue () {
    let file = new FileModel()
    file.values.id = this.id.getValue()
    file.values.contents = this.contents.getValue()
    return file
  }

  setValue (file) {
    this.id.setValue(file.values.id)
    this.contents.setValue(file.values.contents)
  }
}



// WEBPACK FOOTER //
// ./js/modules/file/ui/FileForm.js